import i18n from 'i18next';

export default () => ({
  required_legend: { isDecoration: true, text: i18n.t('required-legend'), type: 'Text' },
});
